export default function Preloader() {

    return (
        <>
            <div className="preloader">
                Loading...
            </div>
        </>
    )
}